"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _reactReduxI18n = require("react-redux-i18n");

var _utils = require("../utils");

var _jsxRuntime = require("react/jsx-runtime");

var styleModal = {
  overlay: {
    backgroundColor: 'rgba(255,255,255,0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  content: {
    backgroundColor: '#fff',
    borderRadius: 4,
    boxShadow: 'rgba(0, 0, 0, 0.15) 0px 0px 32px 0px',
    minWidth: 300,
    outline: 0,
    padding: 20,
    position: 'relative'
  }
};
var closeStyle = {
  border: '0 none',
  background: 'none',
  cursor: 'pointer',
  fontSize: 24,
  height: 14,
  lineHeight: 0,
  padding: 0,
  position: 'absolute',
  right: 10,
  top: 10
};

function MultiProjectChips(props) {
  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      isContactModalOpen = _React$useState2[0],
      setIsContactModalOpen = _React$useState2[1];

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
      "data-id": "open-modal",
      type: "button",
      style: {
        color: _utils.chipColors.PROJECT
      },
      onClick: function onClick() {
        return setIsContactModalOpen(true);
      },
      className: "no-wrap chip m-2 inline-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "dossier.projects"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        "data-id": "nbProjects",
        children: props.dossiers.length
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactModal.default, {
      defaultStyles: styleModal,
      isOpen: isContactModalOpen,
      onRequestClose: function onRequestClose() {
        return setIsContactModalOpen(false);
      },
      shouldCloseOnOverlayClick: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        "data-id": "modal-multi-project-content",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          type: "button",
          style: closeStyle,
          onClick: function onClick() {
            return setIsContactModalOpen(false);
          },
          children: "\xD7"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
            value: "dossier.relatedProjects"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("table", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
            children: props.dossiers.map(function (dossier, index) {
              var project = dossier.project;
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("td", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      style: {
                        color: _utils.chipColors.PROJECT,
                        maxWidth: 300
                      },
                      className: "ellipsis chip m-2",
                      title: project.name,
                      children: project.name
                    })
                  })
                })
              }, index);
            })
          })
        })]
      })
    })]
  });
}

MultiProjectChips.propTypes = {
  dossiers: _propTypes.default.array.isRequired
};
var _default = MultiProjectChips;
exports.default = _default;
//# sourceMappingURL=MultiProjectChips.js.map